// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum MediaRequestSource {
	User = 0,
	Device = 1,
	System = 2,
}

export const MediaRequestSourceDisplayNames: { [key in keyof typeof MediaRequestSource]?: string} = {
	"User": "User",
	0 : "User",
	"Device": "Device",
	1 : "Device",
	"System": "System",
	2 : "System",
}

export const getMediaRequestSourceDisplayName = (key: MediaRequestSource | (keyof typeof MediaRequestSource & string)) => {
	return MediaRequestSourceDisplayNames[key];
}

